import React from "react";

const Divider = ({ className, width = "w-full", margin = 'my-4' }) => {
  return <div className={`h-[1px] bg-grey ${margin} ${className}  ${width}`}></div>;
};

export default Divider;
